import React, { useContext } from 'react';
import { ModuleTestAvailabilityWrapper } from 'components/module-test/test-availability/ModuleTestAvailability.styled';
import { IModule, ITest, IUser } from 'types/app';
import { getLocaleValue } from 'helpers/utils';
import { useTranslation } from 'react-i18next';
import { Container } from 'layout/page/Page.layout.styled';
import { GenericDiv } from 'styles/helpers/utils';
import { prem } from 'styles/helpers/spacing';
import Button from 'components/common/button/Button';
import { disableGetModuleButton, hideGetModuleButton } from 'helpers/modules';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import useIonNavContext from 'hooks/useIonNavContext';
import { ROUTES } from 'constants/routes';
export interface ModuleTestAvailability {
  moduleTestInfos: ITest;
  module: IModule;
}

const ModuleTestAvailability: React.FC<ModuleTestAvailability> = ({
  moduleTestInfos,
  module,
}) => {
  const { i18n, t } = useTranslation('translation');
  const { user } = useContext(UserContext) as UserContextProps;
  const { gotoUrl } = useIonNavContext();

  return (
    <ModuleTestAvailabilityWrapper>
      {module && (
        <Container flexCentered>
          <div className="test-days-left">
            <strong>
              {t('relations.management.test.availabilitytitle', {
                daysLeft: moduleTestInfos.daysLeft,
                daySuffix: moduleTestInfos.daysLeft > 1 ? 's' : '',
                moduleName: getLocaleValue(moduleTestInfos.themeName, i18n.language),
              })}
            </strong>
          </div>
          <div className="get-module">
            {t('relations.management.test.getdescription', {
              daysLeft: moduleTestInfos.usedDay + moduleTestInfos.daysLeft,
            })}
          </div>
          {!hideGetModuleButton(user as IUser) && !disableGetModuleButton(user as IUser) && (
            <GenericDiv width="50%" minWidth={prem(200)} center={true}>
              <Button
                // onClick={() => onBuyModule && onBuyModule()}
                onClick={() => gotoUrl(ROUTES.CONTACT)}
                color="accent"
                fill="outline"
                expand={true}
              >
                {t('common.getmodule')}
              </Button>
            </GenericDiv>
          )}
        </Container>
      )}
    </ModuleTestAvailabilityWrapper>
  );
};

export default ModuleTestAvailability;
